import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  share: defineAsyncComponent(() => import("/vercel/path0/layouts/share.vue").then(m => m.default || m))
}